module.exports = __webpack_public_path__ + "img/hunt_goods.cad04201.png";